module.exports = __webpack_public_path__ + "static/media/Edit.65b6288c.svg";